<script>
export default {
    name: 'SampleEvaluationForm',

    props: {
        languageStrings: {
            type: Object,
            default: null
        },
        sample: {
            type: Object,
            default: null
        }
    },

    emits: ['form-closed'],

    data() {
        return {
            data: this.sample
        }
    },

    methods: {
        // Helpers
        stopEnterPropagation() {
            // dummy to stop click propagation upwards in hierarchy            
        },

        closeForm() {
            this.$emit('form-closed', -1)
        },
        saveForm(type) {
            this.$emit('form-closed', type, this.data)
        }
    }
}
</script>

<template>
    <div class="sample-evaluation-form rows">
        <span class="title">{{ (languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample037 != null ? languageStrings.ui.sample037 : 'Vyhodnocení vzorku') + ' ' + sample.sif }}</span>

            <span>
                {{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample042 != null ? languageStrings.ui.sample042 : 'Celkový závěr' }}
                <select v-model="data.analysisConclusion.generalConclusion">
                    <option :value="0">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample043 != null ? languageStrings.ui.sample043 : 'Vyhovuje' }}</option>
                    <option :value="1">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample048 != null ? languageStrings.ui.sample048 : 'Převážně vyhovující' }}</option>
                    <option :value="2">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample049 != null ? languageStrings.ui.sample049 : 'Hraniční' }}</option>
                    <option :value="3">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample044 != null ? languageStrings.ui.sample044 : 'Nevyhovuje' }}</option>
                </select>
            </span>

            <span>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample045 != null ? languageStrings.ui.sample045 : 'Diagnóza' }}</span>
            <span>
                <textarea v-model="data.analysisConclusion.diagnosis" @keydown.stop="stopEnterPropagation"></textarea>
            </span>

            <span>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sample046 != null ? languageStrings.ui.sample046 : 'Návrh opatření' }}</span>
            <span>
                <textarea v-model="data.analysisConclusion.actions" @keydown.stop="stopEnterPropagation"></textarea>
            </span>

            <div class="sample-evaluation-form-buttons" style="text-align: left;">
                <button :disabled="data.locked" class="button-small" @click="saveForm(0)">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.form001 != null ? languageStrings.ui.form001 : 'Uložit' }}</button>
                <button :disabled="data.locked" class="button-small" @click="saveForm(1)">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.form006 != null ? languageStrings.ui.form006 : 'Uložit a generovat protokol' }}</button>
                <button :disabled="data.locked" class="button-small" style="margin-top: 5px;" @click="saveForm(2)">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.form007 != null ? languageStrings.ui.form007 : 'Uložit, generovat protokol, odeslat a zamknout' }}</button>
                <button class="button-small" style="margin-top: 5px;" @click="closeForm">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.form002 != null ? languageStrings.ui.form002 : 'Zrušit' }}</button>
            </div>
    </div>
</template>